import { useContext } from 'react';
import { Edit } from 'react-feather';
import { Card, CardBody, Col, Form, Input, Label, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import { BILL_MANAGEMENT_CONST, ValidationLabel } from '../../constant';
import OrganizationContext from '../../context/OrganizationContext/OrganizationContext';
import LoaderResoinse from '../../loader/loader';
import BillManagementContext from '../../context/BillManagementContext/BillManagementContext';

const PaymentBillManagementAddModel = (props) => {
  const { onSubmit, close, error } = props;
  const { modal, editIndex, venderBillFormData, setVenderBillFormData } = useContext(BillManagementContext);

  const { loaderShow } = useContext(OrganizationContext);
  const handelChange = (e) => {
    const { name, value } = e.target;
    setVenderBillFormData((prev) => {
      return {
        ...prev,
        [name]: value
      };
    });
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;

    setVenderBillFormData((prev) => ({
      ...prev,
      [name]: files[0] // store File object
    }));
  };

  const paymentType = ['CASH', 'UPI', 'BANK', 'CHEQUE'];
  return (
    <>
      <Modal size="lg" isOpen={modal} toggle={() => close()}>
        {loaderShow === true && <LoaderResoinse />}
        <ModalHeader toggle={() => close()}>
          {!venderBillFormData?.vendorBillId ? (
            <span>{BILL_MANAGEMENT_CONST.ADD_VENDER_BILL}</span>
          ) : (
            <span>
              {BILL_MANAGEMENT_CONST.EDIT_VENDER_BILL} <span> </span>{' '}
            </span>
          )}
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col sm="12">
              <Card>
                <CardBody>
                  <Form className="needs-validation" onSubmit={(e) => onSubmit(e)}>
                    <Row>
                      <Col md="6 mb-4">
                        <Label
                          htmlFor="validationCustom01"
                          className={
                            error && venderBillFormData.billDate?.length <= 0 ? 'validation' : 'non-validation'
                          }
                        >
                          {error && venderBillFormData.billDate?.length <= 0
                            ? ValidationLabel.billRequired
                            : ValidationLabel.billDate}
                        </Label>
                        <Input
                          className={`${
                            error && venderBillFormData.billDate?.length <= 0 ? 'inputValidation' : ''
                          } "form-control`}
                          name="billDate"
                          type="date"
                          id="validationCustom01"
                          onChange={handelChange}
                          value={venderBillFormData.billDate}
                          max={new Date().toISOString().split('T')[0]}
                        />
                        <div className="invalid-feedback">{'Please provide a valid ORG Name.'}</div>
                      </Col>
                      <Col md="6 mb-4">
                        <Label
                          htmlFor="validationCustom01"
                          className={error && !venderBillFormData.totalAmount ? 'validation' : 'non-validation'}
                        >
                          {error && !venderBillFormData.totalAmount
                            ? ValidationLabel.totalAmountRequired
                            : ValidationLabel.totalAmount}
                        </Label>
                        <Input
                          className={`${
                            error && !venderBillFormData.totalAmount ? 'inputValidation' : ''
                          } "form-control`}
                          name="totalAmount"
                          type="number"
                          placeholder="Bill Amount"
                          id="validationCustom01"
                          onChange={handelChange}
                          onWheel={(e) => e.target.blur()}
                          value={venderBillFormData.totalAmount}
                        />
                        <div className="invalid-feedback">{'Please provide a valid ORG Name.'}</div>
                      </Col>
                    </Row>
                    {!venderBillFormData?.vendorBillId && (
                      <Row>
                        <Col md="6 mb-4">
                          <Label
                            htmlFor="validationCustom01"
                            className={error && !venderBillFormData.paymentMode ? 'validation' : 'non-validation'}
                          >
                            {' '}
                            {error && !venderBillFormData.paymentMode
                              ? ValidationLabel.paymentModeRequired
                              : ValidationLabel.paymentMode}
                          </Label>
                          <select
                            className={`${error && !venderBillFormData.paymentMode ? 'inputValidation' : ''} form-select`}
                            name="paymentMode"
                            typeof="number"
                            value={venderBillFormData.paymentMode}
                            onChange={handelChange}
                          >
                            <option value="">--select--</option>
                            {paymentType.map((elem) => {
                              return (
                                <option
                                  value={elem}
                                  key={elem}
                                  selected={elem === venderBillFormData.paymentMode ? 'selected' : ''}
                                >
                                  {elem}
                                </option>
                              );
                            })}
                          </select>
                          <div className="invalid-feedback">{'Please provide a valid ORG Name.'}</div>
                        </Col>
                        <Col md="6 mb-4">
                          <Label htmlFor="validationCustom01" className={'non-validation'}>
                            {'Paid Amount'}
                          </Label>
                          <Input
                            className={`form-control`}
                            name="paidAmount"
                            type="number"
                            placeholder="Paid Amount"
                            id="validationCustom01"
                            onChange={handelChange}
                            onWheel={(e) => e.target.blur()}
                            value={venderBillFormData.paidAmount}
                          />
                          <div className="invalid-feedback">{'Please provide a valid ORG Name.'}</div>
                        </Col>
                      </Row>
                    )}
                    {!venderBillFormData?.vendorBillId && (
                      <Row>
                        <Col md="12 mb-4">
                          <Label htmlFor="validationCustom01" className={'non-validation'}>
                            {'Reference No'}
                          </Label>
                          <Input
                            className={`form-control`}
                            name="referenceNo"
                            type="text"
                            placeholder="Reference No"
                            id="validationCustom01"
                            onChange={handelChange}
                            value={venderBillFormData.referenceNo}
                            onWheel={(e) => e.target.blur()}
                          />
                          <div className="invalid-feedback">{'Please provide a valid ORG Name.'}</div>
                        </Col>
                      </Row>
                    )}

                    <Row>
                      <Col md="12 mb-4">
                        <Label htmlFor="validationCustom09">{'Bill Image'}</Label>
                        <Input
                          className="form-control"
                          name="billImage"
                          type="file"
                          id="validationCustom01"
                          onChange={handleFileChange}
                        />
                        <div className="invalid-feedback">{'Please provide a valid State.'}</div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="12 mb-4">
                        <Label htmlFor="validationCustom09">{'Bill Info'}</Label>
                        <textarea
                          className="form-control"
                          name="notes"
                          id="validationCustom09"
                          type="text"
                          placeholder="Bill Info"
                          onChange={handelChange}
                          value={venderBillFormData.notes}
                        />
                        <div className="invalid-feedback">{'Please provide a valid State.'}</div>
                      </Col>
                    </Row>

                    <Row style={{ paddingTop: '30px' }}>
                      <button
                        className="btn btn-primary"
                        type="submit"
                        value="Submit"
                        disabled={loaderShow === true ? 'disabled' : ''}
                      >
                        {'Submit'}
                      </button>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    </>
  );
};

export default PaymentBillManagementAddModel;
